import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { _getEntityMemberPermissions } from '@/api/entity-roles/queries';
import { useGetUserProfile } from '@/api/user-dashboard/queries';

/** Role ids, not names: membership identity is what the backend's self-widen guard compares. */
export const useCallerHeldRoles = (entityId?: string | null): ReadonlySet<string> => {
  const { user } = useGetUserProfile();
  const memberPermissions = useQuery(_getEntityMemberPermissions(entityId, user?.id));

  return useMemo(() => new Set(memberPermissions.data?.roleIds ?? []), [memberPermissions.data]);
};
